/**
 * Cart Flow Rule — cart blocks must have proper add/remove/total flows.
 */

import type { FeatureRule, RuleViolation, BlockData } from "../types"

function jsonStr(obj: unknown): string {
  return JSON.stringify(obj ?? {})
}

export const cartFlowRule: FeatureRule = {
  id: "cart-flow",
  name: "Shopping Cart Flow",
  detect: (data) => {
    const uiStr = jsonStr(data.ui)
    const flowStr = jsonStr(data.flow)
    return /cart/i.test(uiStr) || /cart/i.test(flowStr)
  },
  check: (data) => {
    const violations: RuleViolation[] = []
    const flowStr = jsonStr(data.flow)
    const uiStr = jsonStr(data.ui)

    // Must have setState with cart.items
    if (!flowStr.includes("cart.items") && !flowStr.includes("cart")) {
      violations.push({
        rule: "cart-missing-state",
        level: "error",
        message: "Cart block has no flow referencing cart state (cart.items). Add setState for cart operations.",
      })
    }

    // Should have iterateOver for cart items
    if (!uiStr.includes("iterateOver")) {
      violations.push({
        rule: "cart-no-iterate",
        level: "warning",
        message: "Cart UI has no iterateOver to display cart items.",
      })
    }

    return violations
  },
}
